<dialog #dialog qai-dialog [heading]="title" [showClose]="true" (closeButtonClicked)="onClose()">
  <div class="content">
    @if (stepType === 'video') {
      <p>{{ 'learningPathway.LEARN_STEP_HELP_VIDEO_P1' | transloco }}</p>
      <p>{{ 'learningPathway.LEARN_STEP_HELP_VIDEO_P2' | transloco }}</p>
      <p>{{ 'learningPathway.LEARN_STEP_HELP_VIDEO_P3' | transloco }}</p>
      <p>{{ 'learningPathway.LEARN_STEP_HELP_VIDEO_P4' | transloco }}</p>
    } @else {
      <p>{{ 'learningPathway.LEARN_STEP_HELP_PDF_P1' | transloco }}</p>
      <p>{{ 'learningPathway.LEARN_STEP_HELP_PDF_P2' | transloco }}</p>
      <p>{{ 'learningPathway.LEARN_STEP_HELP_PDF_P3' | transloco }}</p>
      <p>{{ 'learningPathway.LEARN_STEP_HELP_PDF_P4' | transloco }}</p>
    }
    <p>{{ 'learningPathway.LEARN_STEP_HELP_TROUBLE' | transloco }} <a qai-link target="_blank" href="mailto:help@quantified.ai">{{ 'learningPathway.LEARN_STEP_HELP_EMAIL' | transloco }}</a></p>
    <div class="actions">
      <button qai-button type="button" [kind]="'primary'" [size]="'large'" (click)="onClose()">
        {{ 'learningPathway.LEARN_STEP_HELP_CLOSE' | transloco }}
      </button>
    </div>
  </div>
</dialog>
